import React, { FC, useEffect, useState } from "react";
import { FormGroup, Label, FormFeedback } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface SelectDatePickerProps {
    label?: string;
    name: string;
    value: Date | null | string; 
    setValue: (name: string, value: Date | null | string) => void;
    setError?: (name: string, error: boolean) => void;
    placeholder?: string;
    errorMessage?: string;
    error?: boolean;
    required?: boolean;
    disabled?: boolean;
    tabIndex?: number;
    style?: React.CSSProperties;
    design?: "flex" | "default";
    passCol?: string;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    autoComplete?: string;
    formate?: string;

}

const SelectDatePicker: FC<SelectDatePickerProps> = ({
    label,
    name,
    value,
    setValue,
    setError,
    placeholder = "Select Date",
    errorMessage = "Invalid date",
    error = false,
    required = false,
    disabled = false,
    tabIndex,
    style,
    passCol,
    design,
    onBlur,
    formate,

    autoComplete = "off"
}) => {
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleChange = (date: Date | null) => {
        setValue(name, date ? date : "");  
        if (setError) {
            setError(name, false);
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (!value && setError) {
            setError(name, true);
        }
        onBlur?.(e);
    };

    const flexClass = design === "flex" && windowWidth > 768 ? "d-flex align-items-center" : "";
    const labelWidthClass = design === "flex" && windowWidth > 768 ? "col-3" : "";
    const passColClass = windowWidth > 768 ? passCol : "";

    return (
        <FormGroup className={flexClass}>
            {label && (
                <Label for={name} className={`${design === "flex" ? "mr-5 " : ""}${labelWidthClass}`}>
                    {label}
                    {required && <span className="text-danger ml-2">*</span>}
                </Label>
            )}
            <div className={passColClass}>
                {error && <FormFeedback className="d-block">{errorMessage}</FormFeedback>}
                <DatePicker
                autoComplete="off"
                    id={name}
                    selected={value && value !== "" ? new Date(value) : null}
                    onChange={handleChange}
                    onBlur={handleBlur}
                     dateFormat={formate?formate:"dd/MM/yyyy"}


                    // dateFormat="MMM d"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText={placeholder}
                    disabled={disabled}
                    tabIndex={tabIndex}
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    minDate={new Date(1950, 0, 1)}   // Start year: 1950
                    maxDate={new Date(2050, 11, 31)}  // End year: 2050
                    popperClassName="small-datepicker-dropdown"
                    // customInput={<input autoComplete={autoComplete} className={`form-control ${error ? "is-invalid" : ""}`} />}
                   customInput={
  <input
    autoComplete="off"
    id={name}
    name={name}
    className={`form-control ${error ? "is-invalid" : ""}`}
    onFocus={(e) => {
      // Reinforce autocomplete off for Chrome
      e.target.setAttribute("autocomplete", "off");
    }}
    onKeyDown={(e) => {
      // Optional: prevent typing entirely
      e.preventDefault();
    }}
    readOnly // ✅ This prevents keyboard from appearing on mobile and blocks typing
  />
}

    
                
                />
            </div>

            {/* Style for smaller dropdowns */}
            <style>
                {`
                .small-datepicker-dropdown .react-datepicker__month-dropdown, 
                .small-datepicker-dropdown .react-datepicker__year-dropdown {
                    font-size: 12px;
                    max-height: 150px;
                }
                .react-datepicker__year-dropdown-container,
                .react-datepicker__month-dropdown-container {
                    width: 75px !important;  
                }
                `}
            </style>
        </FormGroup>
    );
};

export default SelectDatePicker;
